// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MIT
import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Observable, of } from 'rxjs';
import { catchError, flatMap, map } from 'rxjs/operators';

import { PolicyService } from '@app/core';
import { PolicyActionTypes, LoadingPolicyAction, CompleteLoadPolicyAction, FailLoadPolicyAction } from './policies.actions';

@Injectable()
export class PoliciesEffects {
  @Effect()
  requestOnLoadPolicies$ = this.actions$.pipe(
    ofType<LoadingPolicyAction>(PolicyActionTypes.POLICIES_LOADING),
    flatMap(action => this.requestPolicies())
  );

  constructor(private actions$: Actions, private policyService: PolicyService) {}

  private requestPolicies(): Observable<CompleteLoadPolicyAction | FailLoadPolicyAction> {
    return this.policyService
      .getList()
      .pipe(map(policies => new CompleteLoadPolicyAction(policies)), catchError(_ => of(new FailLoadPolicyAction())));
  }
}



// WEBPACK FOOTER //
// ./src/app/access-management/state/policies.effects.ts